import actionTypes from './GUIULUIP02ActionType';

/**
 * お役立ち情報
 */
const initialState = {
    isFetching: false,
    data: {},
    isError: false,
    err_type: "",
    err_detail: []
};

/**
 * お役立ち情報を取得するReducer
 * @param {*} state
 * @param {*} action
 */
export const getUsefulInfoDetail = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_USEFUL_INFO_DETAIL_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: {},
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionTypes.GET_USEFUL_INFO_DETAIL_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionTypes.GET_USEFUL_INFO_DETAIL_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionTypes.GET_USEFUL_INFO_DETAIL_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                isError: false,
                data: {},
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
